import React from "react";

// MUI Comp:
import { IconButton,Button } from "@mui/material";

// Styled comp:
import { styled } from '@mui/material/styles';

// icons
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';


const VisuallyHiddenInput = styled('input') ({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

function UploadButton({onFileChange, text}) {

    return(
        <Button
            sx={{padding:'0.5rem'}}
            component="label"
            role={undefined}
            variant="outlined"
            tabIndex={-1}
            startIcon={<AddCircleOutlineIcon sx={{marginLeft:1}} />}
            >
        <VisuallyHiddenInput
            name="media"
            type="file"
            multiple
            accept="image/png, image/jpeg"
            onChange={onFileChange}
        />
        {text}
        </Button>
    );

}

export default UploadButton;